/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';

import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-layout-route-page',
  template: `
    <adn-layout-list-page
      [readOnly]="readOnly">
    </adn-layout-list-page>
  `
})
export class LayoutRoutePageComponent {
  readonly readOnly: boolean;

  constructor(
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
    this.readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageLayouts.apiKey)
      && !this.LocalUserPermissions.hasNetwork(PERMISSIONS.axPublisherAdmin.apiKey);
  }
}
